import { useEffect, useState } from "react";
import DepartmentModal from "./DepartmentModal";
import { getDepartments } from "../../../services/departmentService";
import Toast from "../../../shared/components/Toast";
import DeptDeleteModal from "./DeptDeleteModal";

export default function Department() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [toast, setToast] = useState(null);
  const user = JSON.parse(localStorage.getItem("user") ?? "{}");

  const showToast = (message, type = "success") =>
    setToast({ message, type });

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const res = await getDepartments();
      setDepartments(res?.data || []);
    } catch (err) {
      console.error("Department fetch error:", err);
      showToast(err?.response?.data?.message || "Failed to load departments", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ADD
  const openAdd = () => {
    setEditData(null);
    setShowModal(true);
  };

  // EDIT
  const openEdit = (dept) => {
    setEditData(dept);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditData(null);
  };

  // SAVE (ADD/UPDATE)
  const handleSave = (response, wasEdit) => {
    fetchDepartments();

    showToast(
      response?.message || (wasEdit ? "Department updated successfully" : "Department added successfully"),
    "success"
    );

    closeModal();
  };

  // DELETE SUCCESS
  const handleDeleted = (id, response) => {
    setDepartments((prev) =>
      prev.filter((d) => d.department_id !== id)
    );

    setDeleteRecord(null);
    showToast(response?.message || "Department deleted successfully", "delete");
  };

  return (
    <div className="dash-page">
      <div className="le-page-header">
        <div>
          <div className="dash-page-title">Department</div>
          <div className="dash-page-subtitle">
            System administration and configuration
          </div>
        </div>

   
          <button className="org-btn-save le-add-btn dept-btn" onClick={openAdd}>
            + Add Department
          </button>
       
      </div>

      <div className="le-card">
        {loading ? (
          <div className="le-empty">
            <div className="le-empty-text">Loading departments...</div>
          </div>
        ) : departments.length === 0 ? (
          <div className="le-empty">
            <div className="le-empty-text">
              No departments configured yet.
            </div>

            <button className="le-empty-btn" onClick={openAdd}>
              + Add your first department
            </button>
          </div>
        ) : (
          <div className="table-wrap">
          <table className="le-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Department Name</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {departments.map((d, i) => (
                <tr key={d.department_id}>
                  <td data-label="#">{i + 1}</td>
                  <td data-label="Department Name">{d.department_name}</td>
                  <td data-label="Actions">
                    <div className="le-actions">
                      {/* EDIT */}
                      <span
                        className="action-item edit"
                        onClick={() => openEdit(d)}
                      >
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/1828/1828911.png"
                          alt="edit"
                          className="action-icon"
                        />
                        Edit
                      </span>

                      {/* DELETE */}
                      <span
                        className="action-item delete"
                        onClick={() => setDeleteRecord(d)}
                      >
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/1214/1214428.png"
                          alt="delete"
                          className="action-icon"
                        />
                        Delete
                      </span>
                    </div>
                  </td>
                 
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

      {/* ADD / EDIT MODAL */}
      {showModal && (
        <DepartmentModal
          onClose={closeModal}
          onSave={handleSave}
          editData={editData}
        />
      )}

      {/* DELETE MODAL */}
      {deleteRecord && (
        <DeptDeleteModal
          record={deleteRecord}
          idKey="department_id"
          nameKey="department_name"
          endpoint="/api/departments" 
          onClose={() => setDeleteRecord(null)}
          onDeleted={handleDeleted}
        />
      )}

      {/* TOAST */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}